import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ColDef, Column, ColumnApi, GridApi, GridReadyEvent, ITooltipParams, PaginationChangedEvent } from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { environment } from 'src/environments/environment';
import { CommissionProfileService } from './commission-profile-service';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';
import { ProductService } from '../product-management/product-service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

const { API_URL, defaultPageSize ,defaultPageSizeArr} = environment;
@Component({
  selector: 'app-commission-profile-master',
  templateUrl: './commission-profile-master.component.html',
  styleUrls: ['./commission-profile-master.component.scss']
})
export class CommissionProfileMasterComponent implements OnInit {

  @ViewChild('audittrailModal') audittrailModal: ElementRef;
  
  public permissions : any;
  quickFilterShow :boolean = false;
  ellipses: boolean = true;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  collectiondata: number = 0;
  collectionSize: number = 0;
  currentPage: number = 1;
  maxSize: number;
  public rowData!: any[];
  commissionProfileName : any;
  country : any;
  product : any;
  serviceProvider :any;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  globalSearch: string = '';
  countryDropDown: any[];
  productDropDown: any[];
  serviceProviderDropDown: any[];
  pageNumber : any = 0;
  auditData : any[];
  pageNumberAudit : number = 0;
  pageSizeAudit : number = defaultPageSize;
  currentPageAudit: number = 1;
  collectionSizeAudit: number = 0;
  selectedCommissionProfile : any;
  selectedCommissionProfileName : any;


  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 200,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefs: ColDef[] = [

    { field: 'name',lockVisible:true,sortable: false , headerName: 'Commission Name', resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'productId',lockVisible:true, sortable: false , headerName: 'Product', },
    { field: 'countryId', lockVisible:true,sortable: false ,  headerName: 'Country' },
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'serviceProviderId',lockVisible:true,sortable: false ,  headerName: 'Service Provider', },
    { field: 'agents.length',lockVisible:true,sortable: false ,  headerName: 'Agents' ,cellRenderer: 'agGroupCellRenderer',tooltipValueGetter: (params: ITooltipParams) => {
      console.log(params)
      return params.data.agents.join(', ');
    }},
    { field: 'subAgents.length',lockVisible:true,sortable: false ,  headerName: 'Sub-Agents' ,cellRenderer: 'agGroupCellRenderer',tooltipValueGetter: (params: ITooltipParams) => {
      return params.data.subAgents.join(', ');
    }},
    { field: 'updatedBy',lockVisible:true, sortable: false , headerName: 'Updated By' },
    { field: 'updateDate',lockVisible:true,sortable: false ,   headerName: 'Updated On', },
    { field: 'createdBy',lockVisible:true, sortable: false , headerName: 'Created By' },
    { field: 'createDate',lockVisible:true, sortable: false ,  headerName: 'Created On', },
    {
      field: 'actions',lockVisible:true,sortable: false ,  headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            console.log(param);
            return await this.router.navigate(['commissionProfile/Edit'], {
              queryParams: {
                mid: param?.data?.id,
              }
            })
          },
          buttonIconClass: 'icon-edit',
          buttonVisible :true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log("Row clicked :" + param.data.id);
            this.openModal(this.audittrailModal,param.data.id,param.data.name)
          },
          buttonIconClass: 'icon-book',
          buttonVisible: true
        },
        {
          clicked: async (event: any, param: any) => {
            console.log(param);
            this.alertService.toastWarringMessageAlertWithMessage("Review is pending for "+param.data.name+" by checker");
          },
          buttonIconClass: 'icon-rotate-ccw',
          buttonVisible :false
        },
      ]
    }
  ];

  columnDefAudit : ColDef[] = [
    { field: 'amount_from',  headerName: 'From Amount', },
    { field: 'amount_to',  headerName: 'To Amount', },
    { field: 'commission_type',  headerName: 'Commission Type', },
    { field: 'agent_commission',  headerName: 'Agent Commission', },
    { field: 'sub_agent_commission',  headerName: 'Sub-Agent Commission', },
    { field: 'date_from',  headerName: 'Effective Data' },
    { field: 'status', headerName: 'Status', },
    { field: 'remark',  headerName: 'Remark', },
    { field: 'updated_by', headerName: 'Approved By', },
    { field: 'update_date', headerName: 'Approved On', },
    { field: 'created_by',  headerName: 'Created By', },
    { field: 'create_date', headerName: 'Created On', },
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedAudit: ColDef[] = [...(this.columnDefAudit.filter((col) => !col?.hide))];


  constructor(private router : Router,private commissionService : CommissionProfileService,private alertService : AlertService,private menuService : MenusService,private location: Location,private productService : ProductService,private modalService: NgbModal) { }

  async ngOnInit() {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.productService.getCountryDropdown().subscribe((response:any)=>{
      console.log(response);
      this.countryDropDown = response.response.data;
    })

    this.commissionService.productDropdownForFilter().subscribe((response:any)=>{
      console.log(response);
      this.productDropDown = response.content;
    })

    this.commissionService.serviceProviderDropdownForFilter().subscribe((response:any)=>{
      console.log(response);
      this.serviceProviderDropDown = response.content;
    })
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    if(!this.commissionProfileName){
      this.commissionProfileName = "";
    }
    if(!this.country){
      this.country = null;
    }
    if(!this.product){
      this.product = null;
    }
    if(!this.serviceProvider){
      this.serviceProvider = null;
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + 0);


    return this.commissionService.getCommissionProfileList(this.commissionProfileName,this.country,this.product,this.serviceProvider,this.pageSize,0)
      .subscribe((data:any) => {
        console.log(JSON.stringify(data));
        this.rowData = data.content;
        console.log(" this.rowData= masterlist===" + JSON.stringify(this.rowData))
        this.collectiondata = data.content,
          this.collectionSize = data.totalElements,
          console.log("Collection Size : " + this.collectionSize);

      });
  }

  addNew(){
    this.router.navigate(['commissionProfile/Add']);
  }

  onExportCSV(){
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Commission_Profile_List' + "_" + referenceId;
    if(this.commissionProfileName == null || this.commissionProfileName == ""|| this.commissionProfileName == undefined){
      this.commissionProfileName = "";
    }
    if(this.country == null || this.country == ""){
      this.country = null;
    }
    if(this.product == null || this.product == ""){
      this.product = null;
    }
    if(this.serviceProvider == null || this.serviceProvider == ""){
      this.serviceProvider = null;
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + this.pageNumber);
    return this.commissionService.getCommissionProfileList(this.commissionProfileName,this.country,this.product,this.serviceProvider,this.pageSize,this.pageNumber)
      .subscribe((data:any) => {
        debugger
        const expData: any[] = [];
        console.log("Commission Data ::" + JSON.stringify(data));

        if (data.content.length == 0) {
          this.alertService.errorAlertWithMessage("No records present");
          return
        }
        (data.content || []).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if (!(col?.field == "actions")) {
              if (col?.field) {
                // Handle special array fields for export
                if (col?.field === 'agents.length') {
                  // Export the count of agents
                  tempRec['Agents'] = curr.agents ? curr.agents.length : 0;
                } else if (col?.field === 'subAgents.length') {
                  // Export the count of sub-agents
                  tempRec['Sub-Agents'] = curr.subAgents ? curr.subAgents.length : 0;
                } else {
                  // Regular field mapping - handle nested properties and direct field access
                  const fieldValue = col?.field.includes('.') ? 
                    col.field.split('.').reduce((obj: any, key: string) => obj?.[key], curr) : 
                    curr[col?.field];
                  tempRec[col?.headerName || col?.field] = fieldValue;
                }
              }
            }
          })
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      });
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index = 0;
    this.tableSelectedColumn.forEach((col) => {
      if (!(col?.field == "actions")) {
        // Create a modified column object for proper header naming
        const exportCol = { ...col };
        
        // Fix header names for array fields in export
        if (col?.field === 'agents.length') {
          exportCol.headerName = 'Agents';
        } else if (col?.field === 'subAgents.length') {
          exportCol.headerName = 'Sub-Agents';
        }
        
        tempRec[index] = exportCol;
        index++;
      }
    })
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col: any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col: any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  quickFilterShowAction(data:any){
    this.quickFilterShow = !this.quickFilterShow
  }

  onSearchBtnClick(data :any){
    if(this.commissionProfileName == null || this.commissionProfileName == ""|| this.commissionProfileName == undefined){
      this.commissionProfileName = "";
    }
    if(this.country == null || this.country == ""){
      this.country = null;
    }
    if(this.product == null || this.product == ""){
      this.product = null;
    }
    if(this.serviceProvider == null || this.serviceProvider == ""){
      this.serviceProvider = null;
    }
    return this.commissionService.getCommissionProfileList(this.commissionProfileName,this.country,this.product,this.serviceProvider,this.pageSize,0)
      .subscribe((data:any) => {

        this.rowData = data.content || [],
          this.collectiondata = data.content || 0
          this.collectionSize = data.totalElements
        if (this.rowData.length <= 0) {
          this.alertService.errorAlertWithMessage("No records present");
          return
        }
      });

  }

  closeResult = '';
  openModal(content: any,commissionProfile:String,commissionProfileName:any) {
    this.auditData = [];
    console.log("Commission Profile ID : "+commissionProfile);
    this.selectedCommissionProfileName = commissionProfileName;
    this.selectedCommissionProfile = commissionProfile;
    this.pageNumberAudit = 0;
    this.pageSizeAudit = 10;
    this.commissionService.getCommissionAuditTrail(commissionProfile,this.pageSizeAudit,this.pageNumberAudit).subscribe((response:any)=>{
      console.log(response);
      this.auditData = response.data.content
      console.log(this.auditData);
      this.collectionSizeAudit = response.data.totalElements;
    })

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', centered: true, modalDialogClass: 'permission-modal' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  resetFilter(){
    this.commissionProfileName = "";
    this.country = null;
    this.product = null;
    this.serviceProvider = null;

  }

  updateSelectedColumn(event: any) {
    console.log("select col : " + event.target.checked);
    if (event.target.checked) {
      console.log(this.columnDefsCopy[parseInt(event.target.value)].field);
      console.log(this.permissions);
      if (this.columnDefsCopy[parseInt(event.target.value)].field == "actions" && this.permissions.includes("Add") && this.permissions.includes("Edit")) {
        console.log("Action Disabled");
        this.gridApi.setColumnDefs(this.tableSelectedColumn)
        this.gridApi.setDefaultColDef(this.defaultColDef);
        return;
      }

      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    console.log("selected Column : " + JSON.stringify(this.tableSelectedColumn));

    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  allowAlfanumeric($event: Event): void {
  }
  fun(id: any) {
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id: any) {
    document?.getElementById(id)?.classList.remove("hey")
  }
  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || (charCode == 32)) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
    if(!this.commissionProfileName){
      this.commissionProfileName = "";
    }
    if(!this.country){
      this.country = "";
    }
    if(!this.product){
      this.product = "";
    }
    if(!this.serviceProvider){
      this.serviceProvider = "";
    }
    if(!this.country){
      this.country = "";
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + 0);


    this.commissionService.getCommissionProfileList(this.commissionProfileName,this.country,this.product,this.serviceProvider,this.pageSize,0)
      .subscribe((data:any) => (this.rowData = data.data || data.content || data,
        this.collectiondata = data.totalCount || data.totalRecords,
        this.collectionSize = data.totalElements,
        this.gridApi.applyTransaction({ add: this.rowData })));
    console.log("Collection Size : " + this.collectionSize);

  }

  onPaginationChange(param: PaginationChangedEvent | any) {

    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
    if(!this.commissionProfileName){
      this.commissionProfileName = "";
    }
    if(!this.country){
      this.country = "";
    }
    if(!this.product){
      this.product = "";
    }
    if(!this.serviceProvider){
      this.serviceProvider = "";
    }
    if(!this.country){
      this.country = "";
    }
    console.log("selected pageSize export : " + this.pageSize);
    console.log("selected pageNumber export : " + 0);

    this.pageNumber = (param-1)
    return this.commissionService.getCommissionProfileList(this.commissionProfileName,this.country,this.product,this.serviceProvider,this.pageSize,this.pageNumber)
      .subscribe((data:any) => (this.rowData = data.content ,
        this.collectiondata = data.totalCount || data.totalRecords,
        this.collectionSize = data.totalElements,
        this.gridApi.applyTransaction({ add: this.rowData })));
    console.log("Collection Size : " + this.collectionSize);

  }

  onPageSizeChangesAudit($event: Event) {
    this.pageNumberAudit = 0;
    console.log("selected page size audit: " + this.pageSizeAudit);
    this.commissionService.getCommissionAuditTrail(this.selectedCommissionProfile, this.pageSizeAudit, this.pageNumberAudit)
      .subscribe((data:any) => (
        this.auditData = data.data.content,
        this.collectionSizeAudit = data.data.totalElements));
        console.log("Collection Size : " + this.collectionSizeAudit);

  }

  onPaginationChangeAudit(param: PaginationChangedEvent | any) {

    this.pageNumberAudit = (param-1);
    console.log("selected page number audit: " + this.pageNumberAudit);
    this.commissionService.getCommissionAuditTrail(this.selectedCommissionProfile, this.pageSizeAudit, this.pageNumberAudit)
      .subscribe((data:any) => (
        this.auditData = data.data.content,
        this.collectionSizeAudit = data.data.totalElements));
        console.log("Collection Size : " + this.collectionSizeAudit);

  }

}
